export default __webpack_public_path__ + "static/media/bhattacharya.2cf4e625.mp4";